import { type FC, useState, useRef, useEffect } from 'react'
// import { HiOutlineVolumeOff, HiOutlineVolumeUp } from 'react-icons/hi'
// import { HiOutlineInformationCircle } from 'react-icons/hi2'
// import { HiOutlineTrophy } from 'react-icons/hi2'
import { FaPlus } from 'react-icons/fa'
import { getGalaLink } from 'src/constants'
import GalaIcon from './GalaIcon'
import ButtonTertiary from './ButtonTertiary'
import { useAuth } from 'src/AuthContext'
// import InfoModal from 'src/Dialog/InfoModal'
import Avatar from 'src/User/Avatar'
import ProfileModal from './Dialog/ProfileModal'
import { UserType } from './types'
import { globalEvents } from './events'
// import { useSound } from 'src/Game/SoundContext'

const Header: FC = () => {
  const {
    logIn,
    logOut,
    setIsLoginSplashScreenVisible,
    userProfile,
    useableGala,
  } = useAuth()
  // const [isInfoVisible, setIsInfoVisible] = useState(false)
  const [isProfileVisible, setIsProfileVisibleState] = useState(false)
  // const { isMuted, toggleMute } = useSound()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const setIsProfileVisible = (isVisible: boolean) => {
    setIsProfileVisibleState(isVisible)

    globalEvents.emit('navigate', 'profile')
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // const toggleSound = () => {
  //   globalEvents.emit('buttonPress', 'toggleSound', { isMuted: !isMuted })
  //   toggleMute()
  // }

  // const toggleInfo = () => {
  //   globalEvents.emit('buttonPress', 'toggleInfo', {
  //     isInfoVisible: !isInfoVisible,
  //   })

  //   setIsInfoVisible(!isInfoVisible)
  // }

  // const hideInfo = () => {
  //   setIsInfoVisible(false)
  // }

  const hideProfile = () => {
    setIsProfileVisible(false)
  }

  const handleClickGetGala = () => {
    if (userProfile) {
      window.open(getGalaLink, '_blank')
    } else {
      setIsLoginSplashScreenVisible(true)
    }
  }

  const handleUserAvatarClick = () => {
    if (!userProfile || userProfile.type === UserType.AnonymousUser) {
      logIn()
    } else {
      setIsDropdownOpen(!isDropdownOpen)
    }
  }

  return (
    <>
      <div className="header text-white w-full">
        <div className="py-2 px-4 flex justify-between items-center gap-2 xs:gap-4 sm:gap-6">
          <div
            className="flex items-center xs:w-[3.75rem] relative"
            ref={dropdownRef}
          >
            <button
              aria-label={userProfile ? 'Show profile' : 'Login'}
              onClick={handleUserAvatarClick}
            >
              <Avatar className="w-10 h-10" />
            </button>

            {isDropdownOpen &&
              userProfile &&
              userProfile.type !== UserType.AnonymousUser && (
                <div className="absolute top-full left-0 mt-2 w-48 rounded-md shadow-lg bg-deepblue-950 ring-1 ring-black ring-opacity-5">
                  <div className="py-1" role="menu">
                    <button
                      className="w-full text-left px-4 py-2 text-sm text-white hover:bg-deepblue-800"
                      onClick={() => {
                        setIsProfileVisible(true)
                        setIsDropdownOpen(false)
                      }}
                    >
                      Profile
                    </button>
                    <button
                      className="w-full text-left px-4 py-2 text-sm text-white hover:bg-deepblue-800"
                      onClick={() => {
                        logOut()
                        setIsDropdownOpen(false)
                      }}
                    >
                      Sign out
                    </button>
                  </div>
                </div>
              )}
          </div>

          {/* Middle Section: Balance and Add Button */}
          <div className="flex-grow px-1 max-w-lg xs:-ml-8">
            <div className="flex items-center gap-2 bg-white bg-opacity-10 p-1.5 rounded-2xl">
              <GalaIcon className="w-[1.75rem] h-[1.75rem]" />
              <p className="text-sm font-figtree">
                {Math.floor(useableGala).toLocaleString()} GALA
              </p>
              <ButtonTertiary
                aria-label="Get GALA"
                className="mr-0 ml-auto"
                onClick={handleClickGetGala}
              >
                <FaPlus className="text-white w-4 h-4" />
              </ButtonTertiary>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            {/* <button
              onClick={toggleSound}
              aria-label={isMuted ? 'Mute sound' : 'Unmute sound'}
            >
              {!isMuted && (
                <HiOutlineVolumeUp className="w-6 h-6 text-pinkishpurple-400/75" />
              )}
              {isMuted && (
                <HiOutlineVolumeOff className="w-6 h-6 text-pinkishpurple-400/75" />
              )}
            </button> */}
            {/* <button onClick={toggleInfo} aria-label="How to play">
              <HiOutlineInformationCircle className="text-pinkishpurple-400/75 w-6 h-6" />
            </button> */}
          </div>
        </div>
      </div>
      {/* <InfoModal open={isInfoVisible} onClose={hideInfo} /> */}
      <ProfileModal open={isProfileVisible} onClose={hideProfile} />
    </>
  )
}

export default Header
